import React from 'react';
import GovLogo from '../../../assets/gov-logo-text-black.svg';
import VidaLogo from "../../../assets/logo-vida-blue.svg"
import HeaderText from "../../../assets/boletim-de-ocorrencia-text.svg"
export const PDFHeader = () => {
  return (
    <div style={{width:"100%", display:'flex',flexDirection:"row",alignItems:'center',justifyContent:"space-between"}}>
      <div style={{width:"100%", display:'flex',flexDirection:"row",alignItems:'center',gap:"0.5rem"}}>
        <img src={GovLogo} alt="Prefeitura de Fortaleza"/>
        <img src={HeaderText} alt="PREFEITURA MUNICIPAL DE FORTALEZA AMC - AUTARQUIA MUNICIPAL DE TRÂNSITO E
          CIDADANIA BOLETIM DE OCORRÊNCIA DE ACIDENTES DE TRÂNSITO" />
          
      </div>
        {/* <img src={VidaLogo} alt='Vida'/> */}

    </div>
  );
};
